/**
 * Firebase (projeto de controle de acessos – login único).
 * Banco nomeado: sistemas-amc.
 */
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, doc } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG || '{}');
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app, 'sistemas-amc');

// Região das Functions (ajustar se o projeto usar outra)
const functionsRegion = process.env.REACT_APP_FUNCTIONS_REGION || 'southamerica-east1';
export const functions = getFunctions(app, functionsRegion);

/** systemId do AMC Log no painel de controle de acessos (roles em users, callables) */
export const SYSTEM_ID = 'sistema_amc_log';

/** APP_ID para paths artifacts (artifacts/{appId}/public/data/...). Obrigatório para leitura/escrita de dados. */
export const APP_ID = process.env.REACT_APP_APP_ID || 'amc-log-prod';

/** Path da coleção de encomendas: artifacts/{appId}/public/data/deliveries */
const DELIVERIES_PATH = ['artifacts', APP_ID, 'public', 'data', 'deliveries'];

export function getDeliveriesRef() {
  return collection(db, ...DELIVERIES_PATH);
}

export function getDeliveryDoc(id) {
  return doc(db, ...DELIVERIES_PATH, id);
}

/**
 * Chama a callable validateUserPin do backend (controle de acessos).
 * @param {{ pin: string, targetUid: string }} payload
 * @returns {Promise<{ valid: boolean }>}
 */
export async function validateUserPin(payload) {
  const callable = httpsCallable(functions, 'validateUserPin');
  const result = await callable(payload);
  return result.data;
}

/**
 * Chama a callable amcLogDeleteDelivery para exclusão permanente de entrega.
 * Requer admin do AMC Log ou admin global.
 * @param {string} deliveryId - ID do documento da entrega
 * @returns {Promise<{ success: boolean }>}
 */
export async function deleteDelivery(deliveryId) {
  const callable = httpsCallable(functions, 'amcLogDeleteDelivery');
  const result = await callable({ appId: APP_ID, deliveryId });
  return result.data;
}

/**
 * Busca logs de auditoria de exclusões de entregas.
 * Requer admin do AMC Log (roles.sistema_amc_log === 'admin').
 * @returns {Promise<{ logs: Array }>}
 */
export async function getDeletionAuditLogs() {
  const callable = httpsCallable(functions, 'amcLogGetDeletionAuditLogs');
  const result = await callable({ appId: APP_ID });
  return result.data;
}

/**
 * Apaga um log de auditoria de exclusão.
 * Requer isAdmin global (campo users/{uid}.isAdmin — diferente do admin do AMC Log).
 * @param {string} auditLogId
 * @returns {Promise<{ success: boolean }>}
 */
export async function deleteAuditLog(auditLogId) {
  const callable = httpsCallable(functions, 'amcLogDeleteAuditLog');
  const result = await callable({ appId: APP_ID, auditLogId });
  return result.data;
}
